// extracted by mini-css-extract-plugin
module.exports = {"fade":"transition_fade__NC56g","fadeIn":"transition_fadeIn__M72gD","In":"transition_In__HC_I0"};